import {
  Alert,
  AlertIcon,
  Button,
  Modal,
  ModalBody,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Text,
} from '@chakra-ui/react';
import React from 'react';

import { MosPosDiff, MosPosMenu } from '@/services/MosPosMenuMaster';

type Props = {
  isOpen: boolean;
  diff: MosPosDiff;
  menus: MosPosMenu[];
  isImporting: boolean;
  onCancel: () => void;
  onConfirm: () => void;
};

/** 登録前の最終確認。モックどおり対象件数と一括反映ポリシーを示します。 */
export const ImportConfirmModal: React.FC<Props> = ({
  isOpen,
  diff,
  isImporting,
  onCancel,
  onConfirm,
}) => {
  return (
    <Modal isOpen={isOpen} onClose={onCancel} isCentered>
      <ModalOverlay />
      <ModalContent
        data-testid="confirm-modal-content"
        style={{ borderRadius: '5px', maxWidth: '460px', overflow: 'hidden' }}
      >
        <ModalHeader
          data-testid="confirm-modal-header"
          style={{
            borderBottom: '1px solid #E2E8F0',
            fontSize: '16px',
            padding: '16px 20px',
          }}
        >
          この内容で登録しますか？
        </ModalHeader>
        <ModalBody style={{ padding: '20px' }}>
          <Text
            data-testid="confirm-summary"
            style={{ fontSize: '14px', marginBottom: '14px' }}
          >
            新規 {diff.new} 件・更新 {diff.update} 件を登録します。
          </Text>
          <Alert
            status="warning"
            data-testid="confirm-policy"
            style={{
              alignItems: 'flex-start',
              background: '#FFFAF0',
              border: '1px solid #FBD38D',
              borderRadius: '4px',
              color: '#975A16',
              fontSize: '12px',
              lineHeight: 1.7,
              padding: '10px 12px',
            }}
          >
            <AlertIcon color="#975A16" style={{ marginTop: '2px' }} />
            この操作は一括で反映され、一部のみの反映はできません。エラー発生時はすべてロールバックされ、既存データは変更されません。
          </Alert>
        </ModalBody>
        <ModalFooter
          data-testid="confirm-modal-footer"
          style={{ borderTop: '1px solid #E2E8F0', gap: '10px' }}
        >
          <Button variant="ghost" onClick={onCancel} isDisabled={isImporting}>
            キャンセル
          </Button>
          <Button
            colorScheme="darkBlue"
            onClick={onConfirm}
            isDisabled={isImporting}
            isLoading={isImporting}
            data-testid="confirm-register"
          >
            登録する
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal>
  );
};
